import { RefreshCw, FileSpreadsheet } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { TIPOLOGIA_OPTIONS } from "@/components/careers/ApplicationForm";
import { STATUS_LABELS } from "@/components/admin/applications/StatusControls";

export const ApplicationsFilters = ({ filters, onChange, onRefresh, onExport, exporting }) => {
  const update = (patch) => onChange((f) => ({ ...f, ...patch }));
  return (
    <div className="mt-10 flex flex-wrap items-end gap-4 border border-navy/10 bg-white p-5">
      <div>
        <Label className="text-xs uppercase tracking-widest text-slate-500">Ricerca</Label>
        <Input className="mt-1 w-56" placeholder="Nome, email, università" value={filters.q} onChange={(e) => update({ q: e.target.value })} data-testid="app-filter-search" />
      </div>
      <div>
        <Label className="text-xs uppercase tracking-widest text-slate-500">Tipologia</Label>
        <Select value={filters.tipologia} onValueChange={(v) => update({ tipologia: v })}>
          <SelectTrigger className="mt-1 w-56" data-testid="app-filter-tipologia"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="tutte">Tutte le tipologie</SelectItem>
            {TIPOLOGIA_OPTIONS.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label className="text-xs uppercase tracking-widest text-slate-500">Stato</Label>
        <Select value={filters.status} onValueChange={(v) => update({ status: v })}>
          <SelectTrigger className="mt-1 w-44" data-testid="app-filter-status"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="tutti">Tutti gli stati</SelectItem>
            {Object.entries(STATUS_LABELS).map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <label className="flex h-9 items-center gap-2 text-sm text-navy">
        <Checkbox checked={filters.highOnly} onCheckedChange={(v) => update({ highOnly: !!v })} data-testid="app-filter-high-media" />
        Solo media ≥ 27
      </label>
      <div className="ml-auto flex items-center gap-2">
        <Button variant="outline" size="sm" onClick={onRefresh} data-testid="app-filter-refresh" className="h-9"><RefreshCw className="h-4 w-4" /> Aggiorna</Button>
        <Button size="sm" onClick={onExport} disabled={exporting} data-testid="app-export-csv" className="h-9 bg-navy text-white hover:bg-navy-800">
          <FileSpreadsheet className="h-4 w-4" /> {exporting ? "Esportazione..." : "Esporta CSV"}
        </Button>
      </div>
    </div>
  );
};
